import { UPDATE_DATA, SAVE_DATA, SAVE_SUCCESS_RESPONSE } from './constants';

export function saveCar() {
  return {
    type: SAVE_DATA
  };
}

/**
 *
 * @param car
 * @returns {{car: *, type: *}}
 */
export function updateCar(car) {
  return {
    type: UPDATE_DATA,
    car,
  };
}

export function requestSuccess(response) {
  return {
    type: SAVE_SUCCESS_RESPONSE,
    response,
  };
}
